import { Link } from 'react-router-dom';
import DarkModeToggle from './DarkModeToggle';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-black dark:to-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
              <img src="/apple-touch-icon.png" alt="EightyThreeLabs" className="w-8 h-8" />
              <span className="text-xl font-semibold">
                <span className="text-brand-primary">EightyThree</span>
                <span className="text-black dark:text-white">Labs</span>
              </span>
            </Link>
            
            {/* Dark Mode Toggle */}
            <DarkModeToggle />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white dark:bg-gray-900 rounded-3xl p-12 shadow-xl">
          <Link 
            to="/" 
            className="inline-flex items-center text-brand-primary hover:text-green-700 dark:hover:text-green-400 mb-8 transition-colors"
          >
            ← Back to Home
          </Link>
          
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4 text-center">Terms of Service</h1>
          <div className="text-center text-gray-600 dark:text-gray-400 mb-8 italic">
            Effective Date: January 1, 2025
          </div>
          
          <div className="prose max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 dark:text-gray-300">
                By accessing and using EightyThreeLabs ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. Description of Service</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">EightyThreeLabs provides online brain training games and educational puzzles designed to improve cognitive abilities, mathematical skills, and logical thinking. Our services include:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Daily Math Challenge games</li>
                <li>Sum Grid Puzzles</li>
                <li>Multiplication Grid challenges</li>
                <li>Combined Grid puzzles</li>
                <li>Progress tracking and statistics</li>
                <li>Newsletter and educational content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. User Accounts</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">To access certain features, you may need to create an account. You are responsible for:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Providing accurate and current information</li>
                <li>Notifying us immediately of any unauthorized use of your account</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Acceptable Use</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">You agree to use our Service only for lawful purposes and in accordance with these Terms. You agree NOT to:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Use the Service for any illegal or unauthorized purpose</li>
                <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
                <li>Use automated scripts, bots, or other means to manipulate game scores</li>
                <li>Interfere with or disrupt the Service or servers connected to the Service</li>
                <li>Transmit any viruses, malware, or other harmful code</li>
                <li>Harass, abuse, or harm other users</li>
                <li>Violate any applicable local, state, national, or international law</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Intellectual Property Rights</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">The Service and its original content, features, and functionality are owned by EightyThreeLabs and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws. You may not:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Copy, modify, or distribute our games or content</li>
                <li>Reverse engineer or attempt to extract source code</li>
                <li>Use our trademarks without permission</li>
                <li>Create derivative works based on our content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">6. Subscription and Payment Terms</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">Some features may require a subscription or payment. If applicable:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Subscription fees are charged in advance</li>
                <li>You may cancel your subscription at any time</li>
                <li>Refunds are provided according to our refund policy</li>
                <li>We may change subscription fees with advance notice</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">7. Service Availability</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">We strive to maintain high availability, but we do not guarantee that the Service will be available at all times. The Service may be temporarily unavailable due to:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Scheduled maintenance</li>
                <li>Technical issues</li>
                <li>Force majeure events</li>
                <li>Third-party service disruptions</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">8. Limitation of Liability</h2>
              <p className="text-gray-700 dark:text-gray-300">
                To the maximum extent permitted by law, EightyThreeLabs shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses resulting from your use of the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">9. Termination</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will cease immediately.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">10. Changes to Terms</h2>
              <p className="text-gray-700 dark:text-gray-300">
                We reserve the right to modify these Terms at any time. If we make material changes, we will notify you by posting the updated Terms on our website with a new effective date. Your continued use of the Service after such modifications constitutes acceptance of the updated Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">11. Contact Information</h2>
              <p className="text-gray-700 dark:text-gray-300">
                If you have any questions about these Terms of Service, please contact us through our website at <Link to="/" className="text-brand-primary hover:text-green-700 dark:hover:text-green-400 transition-colors">eightythreelabs.com</Link>.
              </p>
            </section>
          </div>

          <hr className="my-8 border-gray-200 dark:border-gray-700" />
          
          <p className="text-center text-gray-500 dark:text-gray-400 text-sm">
            © 2025 EightyThreeLabs. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;